import styles from './Card.module.scss';

export interface CardProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  testId: string;
  variant?: 'primary' | 'secondary' | 'outlined';
  selected?: boolean;
  transparent?: boolean;
}

export const Card = ({
  testId,
  variant = 'primary',
  selected = false,
  transparent = false,
  ...props
}: CardProps) => {
  return (
    <div
      {...props}
      className={`${styles.card} ${props.className || ''}`}
      data-test-id={testId}
      data-variant={variant}
      data-selected={selected}
      data-transparent={transparent}
    />
  );
};
